import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import OperationsService from "../../../../../services/Production/OperationsService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import WorkstationService from "../../../../../services/Production/WorkstationService";
import withLoader from "../../../../../components/layouts/WithLoader";
const styles = {
    container: (base) => ({
        ...base,
        flex: 1,
    }),
};
const OperationsDetails = ({startLoading,stopLoading}) => {
    const navigate = useNavigate();
    const animatedComponents = makeAnimated();
    const [operation, setOperation] = useState(null);

    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [description, setDescription] = useState("");
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [defaultWorkstationId, setDefaultWorkstationId] = useState(0);
    const [availableWorkstation, setAvailableWorkstation] = useState([]);
    const [selectedOptionWorkstation, setSelectedOptionWorkstation] =
        useState(null);

    const [workstationSelectPlaceHolder, setWorkstationSelectPlaceHolder] =
        useState("Choisir une station de travail");
    useEffect(() => {
        startLoading();
        OperationsService.getOperationById(sessionStorage.getItem("idOperation"))
            .then((response) => {
                if (response.data.success) {
                    setOperation(response.data.success);
                    setDefaultWorkstationId(response.data.success.defaultWorkstation?.id);
                    setName(response.data.success?.name);
                    setCode(response.data.success?.code);
                    setDescription(response.data.success?.description);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : pas d'opération");
                }
            })
            .catch((e) => {
                console.log("error", e);
            }).finally(()=>{
                stopLoading()
            });
        WorkstationService.allWorkstations(getCurrentUserId())
            .then((response) => {
                if (response.data.success) {
                    response.data.success.map((element, i) => {
                        setAvailableWorkstation((oldArray) => [
                            ...oldArray,
                            {
                                value: element.id,
                                label: element.code + " " + element.name,
                            },
                        ]);
                    });
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : pas de station de travail");
                }
            })
            .catch((e) => {
                console.log("error in getAllRealWarehouse", e);
            });
    }, []);

    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };

    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };

    const onChangeDescriptionHandler = (event) => {
        setDescription(event.target.value);
    };

    const onChangeCodeHandler = (event) => {
        setCode(event.target.value);
    };
    const onChangeNameHandler = (event) => {
        setName(event.target.value);
    };

    const onChangeSelectedWorkstation = (selectedOption) => {
        setSelectedOptionWorkstation();
        setDefaultWorkstationId(selectedOption.value);
    };
    const onValidOperationHandler = () => {
        // let operationModel = {
        //     idOperation: sessionStorage.getItem("idOperation"),
        //     name: name,
        //     code: code,
        //     idUser: getCurrentUserId(),
        //     descriptions: description,
        //     defaultWorkstationId: defaultWorkstationId,
        // };
        startLoading()
        OperationsService.updateOperationWorkstation(getCurrentUserId(),sessionStorage.getItem("idOperation"),defaultWorkstationId)
            .then((response) => {
                if (response.data["success"]) {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                        navigate(`/operations`);
                    }, 2000);
                }
            })
            .catch((e) => {
                console.log("error", e);
            }).finally(()=>{
                stopLoading()
            })
    };

    return (
        operation !== null && (
            <div className="content-wrapper" style={{ marginTop: "0" }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <ol class="breadcrumb float-sm-right">
                                    <li class="breadcrumb-item">Home</li>
                                    <li class="breadcrumb-item active">Modifier Opération</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content ">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-dark">
                                    <div className="card-header">
                                        <h5 className="card-title"> Ajouter une Opération</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                        <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="inputName">Code</label>
                                                    <input
                                                        defaultValue={operation.code}
                                                        // placeholder="Ajouter réference "
                                                        onChange={onChangeCodeHandler}
                                                        type="text"
                                                        id="inputName"
                                                        className="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="inputName">Libellé</label>
                                                    <input
                                                        defaultValue={operation.name}
                                                        // placeholder="Ajouter libellé "
                                                        onChange={onChangeNameHandler}
                                                        type="text"
                                                        id="inputName"
                                                        className="form-control"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                           
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label>Station de tarvail Actuelle : </label>
                                                    
                                                    <label>{operation.defaultWorkstation?.code}-{operation.defaultWorkstation?.name}</label>


                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label>Choisir une station de travail</label>

                                                    <Select
                                                        styles={styles}
                                                        // isMulti
                                                        closeMenuOnSelect={true}
                                                        components={animatedComponents}
                                                        defaultValue={selectedOptionWorkstation}
                                                        onChange={onChangeSelectedWorkstation}
                                                        options={availableWorkstation}
                                                        placeholder={workstationSelectPlaceHolder}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-group">
                                                    <label htmlFor="inputDescription">Description</label>
                                                    <textarea
                                                        defaultValue={operation.description}
                                                        // placeholder="Saisir..."
                                                        onChange={onChangeDescriptionHandler}
                                                        id="inputDescription"
                                                        className="form-control"
                                                        rows={2}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card-footer" style={{ marginTop: "1%" }}>
                                        <button
                                            class="btn btn-dark float-right"
                                            style={{ marginTop: "1%" }}
                                            onClick={onValidOperationHandler}
                                        >
                                            Confirmer
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Snackbar
                    open={openErrorAlert}
                    autoHideDuration={2000}
                    onClose={handleEroorClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert variant="filled" onClose={handleEroorClose} severity="error">
                        {errorAlertText}
                    </Alert>
                </Snackbar>

                <Snackbar
                    open={openSuccessAlert}
                    autoHideDuration={2000}
                    onClose={handleSuccessClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert
                        variant="filled"
                        onClose={handleSuccessClose}
                        severity="success"
                    >
                        {successAlertText}
                    </Alert>
                </Snackbar>
            </div>
        )
    );
};
export default withLoader(OperationsDetails);
